import _styled from "@emotion/styled/base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

export var MenuButton = /*#__PURE__*/_styled("button", true ? {
  target: "ertak0t0"
} : {
  target: "ertak0t0",
  label: "MenuButton"
})(true ? {
  name: "1te1vur",
  styles: "position:relative;cursor:pointer"
} : {
  name: "1te1vur",
  styles: "position:relative;cursor:pointer",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi93b3JrZGlyL2xpYnMvbWF0Y2hhL3JlY2lwZXMvTmF2aWdhdGlvbjIvTW9iaWxlTmF2aWdhdGlvbi9OYXZiYXIvQnV0dG9uL0J1dHRvbi52aWV3cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFdUMiLCJmaWxlIjoiL3dvcmtkaXIvbGlicy9tYXRjaGEvcmVjaXBlcy9OYXZpZ2F0aW9uMi9Nb2JpbGVOYXZpZ2F0aW9uL05hdmJhci9CdXR0b24vQnV0dG9uLnZpZXdzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5cbmV4cG9ydCBjb25zdCBNZW51QnV0dG9uID0gc3R5bGVkLmJ1dHRvbmBcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xuICBjdXJzb3I6IHBvaW50ZXI7XG5gXG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});